import { LINE_HEIGHT_TYPES } from './lineHeightConfig';

/**
 * setLineHeight — applies line-height to paragraph/heading/list container nodes in selection.
 * For lists: applies to the bulletList/orderedList container (CSS inherits to list items).
 * @param {number} value
 */
export const setLineHeight =
    (value) =>
    ({ tr, state, dispatch }) => {
        const { from, to } = state.selection;
        let modified = false;

        state.doc.nodesBetween(from, to, (node, pos, parent) => {
            if (!LINE_HEIGHT_TYPES.includes(node.type.name)) return true;  // descend
            if (parent?.type.name === 'listItem') return false;            // paragraph inside list item — skip

            tr.setNodeMarkup(pos, null, { ...node.attrs, lineHeight: value });
            modified = true;
            return false; // block found — stop descent
        });

        if (!modified) return false;
        if (dispatch) dispatch(tr);
        return true;
    };
